import { login, logout, getUserInfo } from '@/api/login'
import { setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import * as types from '../mutaion-types'
import storage from '@/utils/storage'

const user = {
  state: {
    token: '',
    //roles: [],
    name: '',
    //avatar: '',
    //introduction: '',
    userType: '',//用户类型
    menuList: '',//菜单权限列表
    areaList: '',//省市区列表
    realName:'',//用户姓名
  },
  mutations: {
    [types.SET_TOKEN]: (state, token) => {
      state.token = token
    },
    // [types.SET_ROLES]: (state, roles) => {
    //   state.roles = roles
    // },
    // [types.SET_INTRODUCTION]: (state, introduction) => {
    //   state.introduction = introduction
    // },
    [types.SET_NAME]: (state, name) => {
      state.name = name
    },
    [types.SET_AREALIST]: (state, areaList) => {
      state.areaList = areaList
    },
    [types.SET_MENULIST]: (state, menuList) => {
      state.menuList = menuList
    },
    [types.SET_USERTYPE]: (state, userType) => {
      state.userType = userType
    },
    [types.SET_REALNAME]: (state, realName) => {
      state.realName = realName
    },
  },
  actions: {
    loginbyUser({ commit }, { username, password }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await login(username, password)
          // const response = {
          //   data:{
          //       roles: ['15888059646'],
          //       token: 'admin',
          //       introduction: 'i am admin',
          //       avatar: 'https://i.loli.net/2018/05/26/5b0930d3ab3aa.jpg',
          //       name: 'Admin'
          //   }
          // }
          if (response.code == 200) {
            commit(types.SET_NAME, response.data.username)
            commit(types.SET_REALNAME, response.data.realName)
            commit(types.SET_TOKEN, response.data.username)
            setToken(response.data.username)
            Cookies.set('user', username)
          }
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    logout({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          let response = await logout()
          if (response.code == 200) {
            // commit(types.SET_ROLES, '')
            // commit(types.SET_ROLES, [])
            Cookies.remove('user', { path: '' })
            storage.remove('areaList')
            storage.remove('permissions')
            removeToken()
          }
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    felogout({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit(types.SET_TOKEN, '')
          storage.remove('permissions')
          removeToken()
          resolve()
        } catch(error){
          reject();
        }
      })
    },
    getUserInfo({ commit }) {
      return new Promise(async (resolve, reject) => {
       try {
          const response = await getUserInfo(Cookies.get('user'))
          // const response = {
          //   data: {
          //     roles: ['15888059646'],
          //     token: 'admin',
          //     introduction: 'i am admin',
          //     avatar: 'https://i.loli.net/2018/05/26/5b0930d3ab3aa.jpg',
          //     name: 'Admin'
          //   }
          // }
          const { userType, areaList, menuList,realName } = response.data
          //commit(types.SET_ROLES, roles)
          commit(types.SET_USERTYPE, userType)
          commit(types.SET_AREALIST, areaList)
         commit(types.SET_MENULIST, menuList)
         commit(types.SET_REALNAME, realName)
          // commit(types.SET_AVATAR, userType)
          // commit(types.SET_INTRODUCTION, introduction)
          resolve(response)
        }
        catch (error) {
          reject(error)
        }
      })
    }
  }
}

export default user
